(function(){
  var gate = document.getElementById('ts-gate');
  if(!gate) return;

  document.body.classList.add('ts-gate-locked');

  var authView   = gate.querySelector('[data-view="auth"]');
  var verifyView = gate.querySelector('[data-view="verify"]');
  var tabs       = gate.querySelectorAll('.ts-gate-tab');
  var panes      = gate.querySelectorAll('.ts-gate-pane');
  var registerForm = gate.querySelector('#ts-gate-register-form');
  var ageCheck   = gate.querySelector('.ts-gate-age');
  var regSubmit  = registerForm ? registerForm.querySelector('.ts-gate-submit') : null;
  var firstNameInput = gate.querySelector('#ts-reg-first');

  /* Tab switch */
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var mode = tab.dataset.mode;
      tabs.forEach(function(t){
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      panes.forEach(function(p){
        p.hidden = (p.dataset.pane !== mode);
      });
      authView.dataset.mode = mode;
    });
  });

  /* Password toggle */
  gate.querySelectorAll('.ts-gate-eye').forEach(function(btn){
    btn.addEventListener('click', function(){
      var targetId = btn.dataset.togglePw;
      var input = document.getElementById(targetId);
      if(!input) return;
      var open  = btn.querySelector('.ts-gate-eye-open');
      var close = btn.querySelector('.ts-gate-eye-closed');
      if(input.type === 'password'){
        input.type = 'text';
        if(open)  open.style.display  = 'none';
        if(close) close.style.display = '';
      } else {
        input.type = 'password';
        if(open)  open.style.display  = '';
        if(close) close.style.display = 'none';
      }
    });
  });

  /* Age check gates register CTA */
  if(ageCheck && regSubmit){
    var toggleReg = function(){ regSubmit.disabled = !ageCheck.checked; };
    ageCheck.addEventListener('change', toggleReg);
    toggleReg();
  }

  /* Derive first_name from email for Shopify create_customer */
  if(registerForm && firstNameInput){
    var emailInput = registerForm.querySelector('input[type="email"]');
    if(emailInput){
      emailInput.addEventListener('input', function(){
        var localPart = (emailInput.value.split('@')[0] || 'Researcher').replace(/[^a-zA-Z0-9]/g, ' ').trim() || 'Researcher';
        firstNameInput.value = localPart.slice(0, 40);
      });
    }
  }

  /* Verify view swap */
  function showVerify(email){
    if(!verifyView || !authView) return;
    authView.hidden   = true;
    verifyView.hidden = false;
    var strong = verifyView.querySelector('[data-verify-email]');
    if(strong && email) strong.textContent = email;
  }
  function showAuth(){
    if(!verifyView || !authView) return;
    verifyView.hidden = true;
    authView.hidden   = false;
  }

  var params = new URLSearchParams(window.location.search);
  if(params.get('verify') === '1' || params.get('registered') === '1'){
    showVerify(params.get('email') || '');
  }

  var backBtn = verifyView && verifyView.querySelector('[data-back]');
  if(backBtn) backBtn.addEventListener('click', showAuth);
})();